module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "enterpriserVo",
    staticStyle: {
      "margin": "15px",
      "width": "80%",
      "min-width": "800px"
    },
    attrs: {
      "model": _vm.enterpriserVo,
      "inline": true,
      "label-width": "100px",
      "size": "mini"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称"
    }
  }, [_c('el-col', [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    on: {
      "blur": function($event) {
        return _vm.getEnterpriseByCenterData()
      }
    },
    model: {
      value: (_vm.enterpriserVo.name),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "name", $$v)
      },
      expression: "enterpriserVo.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.legalPerson),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "legalPerson", $$v)
      },
      expression: "enterpriserVo.legalPerson"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业范围"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "businessScope", $$v)
      },
      expression: "enterpriserVo.businessScope"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址"
    }
  }, [_c('el-col', [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    model: {
      value: (_vm.enterpriserVo.regAddr),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "regAddr", $$v)
      },
      expression: "enterpriserVo.regAddr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人性质"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.taxpayerType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "taxpayerType", $$v)
      },
      expression: "enterpriserVo.taxpayerType"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.taxpayerNum),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "taxpayerNum", $$v)
      },
      expression: "enterpriserVo.taxpayerNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.openingBank),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "openingBank", $$v)
      },
      expression: "enterpriserVo.openingBank"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行账户"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "bankAccount", $$v)
      },
      expression: "enterpriserVo.bankAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.linkMan),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "linkMan", $$v)
      },
      expression: "enterpriserVo.linkMan"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.linkPhone),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "linkPhone", $$v)
      },
      expression: "enterpriserVo.linkPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4e42fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personalinfo/affiliate_company.vue
// module id = 1186
// module chunks = 10